import api from './api';

const LAMP_CATEGORY = 'lamp'; // Lowercase to match database

/**
 * Fetch all components for a category (bases, shades, colors)
 * Returns ONLY active components (isActive = true)
 */
export const getComponentsByCategory = async (category = LAMP_CATEGORY) => {
  const response = await api.get(`/products/${category}/components`);
  return response.data;
};

/**
 * Fetch components by category and type
 * @param {string} category - e.g., 'lamp'
 * @param {string} type - e.g., 'base', 'shade', 'color'
 * Returns ONLY active components (isActive = true)
 */
export const getComponents = async (category, type) => {
  const response = await api.get('/products/components', {
    params: { category, type }
  });
  return response.data;
};

/**
 * Fetch lamp bases (only active)
 */
export const getLampBases = async () => {
  return getComponents(LAMP_CATEGORY, 'base');
};

/**
 * Fetch lamp shades (only active)
 */
export const getLampShades = async () => {
  return getComponents(LAMP_CATEGORY, 'shade');
};

/**
 * Fetch lamp colors (only active)
 */
export const getLampColors = async () => {
  return getComponents(LAMP_CATEGORY, 'color');
};

/**
 * Fetch all lamp components grouped by type
 * Returns: { bases: [...], shades: [...], colors: [...] }
 */
export const getAllLampComponents = async () => {
  const [basesRes, shadesRes, colorsRes] = await Promise.all([
    getLampBases(),
    getLampShades(),
    getLampColors(),
  ]);

  return {
    bases: basesRes.success ? basesRes.data : [],
    shades: shadesRes.success ? shadesRes.data : [],
    colors: colorsRes.success ? colorsRes.data : [],
  };
};

export default {
  getComponentsByCategory,
  getComponents,
  getLampBases,
  getLampShades,
  getLampColors,
  getAllLampComponents,
};

